import React from 'react';
import { Table, Empty, Button, Input, Checkbox, Form, Tooltip, Select } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import { VALIDAR_STOCK, VENTA_PRECIO_UNITARIO_INCLUYE_IGV, CONVERSION_MEDIDA, INCREMENTO_PV, VENTA_DECIMAL, SERIE_POR_PRODUCTO, LOGISTICA_PRODUCTOS_CON_LOTE } from '../../../../common/types/parametroType';
import { PRECIO_VENTA } from '../../../../common/types/tipoListaPrecioType';

import global from '../../../../common/utility/global';
import auth from '../../../../common/utility/auth';
const { Option } = Select;

export default function Productos(props) {
    const validarStock = auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false;
    const precioUnitarioInclIGV = auth.user().parametros.filter(m => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;
    const conversionMedida = auth.user().parametros.filter(m => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;
    const impresionVU = auth.user().parametros.filter(m => m.abreviatura === INCREMENTO_PV)[0].valor === "1" ? true : false;
    const precioVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 5;
    const cantidadVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 3;
    const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;
    const mostrarLote = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;

    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 20,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        key: 'asignar-serie-button',
                        align: 'center',
                        width: (seriePorProducto) ? 30 : 0,
                        fixed: 'left',
                        render: (value, row, index) => (

                            <span>
                                <div className="custom-options" hidden={seriePorProducto ? false : true}>
                                    <Tooltip placement="top" title="Buscar Serie">
                                        <Button
                                            type="primary"
                                            icon="bars"
                                            size={"small"}
                                            disabled={row.flagAplicarSerie ? false : true}
                                            onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue, index)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: '',
                        dataIndex: 'precioPromedio',
                        width: 0,
                        key: 'precioPromedio',
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrPrecioPromedio[${row.identifier}]`, { initialValue: value })(
                                        <Input hidden />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: '',
                        dataIndex: 'porcentajeMargenComercial',
                        width: 0,
                        key: 'porcentajeMargenComercial',
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrPorcentajeMargenComercial[${row.identifier}]`, { initialValue: value })(
                                        <Input hidden />
                                    )}
                                </div>
                            );
                        }
                    },

                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 85,
                        ellipsis: true,
                        fixed: props.isMobile ? null : 'left',
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrcodigo[${row.identifier}]`, {
                                        initialValue: value
                                    })(

                                        row.isItemLibre ?
                                            <Input
                                                placeholder="Codigo"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCalculateDetail(row, "arrcodigo", e.target.value, 0, index)}
                                            />
                                            : <span>{value}</span>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 220,
                        fixed: props.isMobile ? null : 'left',
                        render: (value, row) => {
                            return (
                                <div
                                    onClick={() => props.onEditarNombreProducto(row, props.onSetFieldsValue, props.onGetFieldValue)}
                                >
                                    {props.onGetFieldDecorator(`arrNombre[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrNombre[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}
                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: (mostrarLote) ? 'Lote' : '',
                        dataIndex: 'numeroLote',
                        width: (mostrarLote) ? 100 : 0,
                        key: 'numeroLote',
                        render: (value, row) => {
                            return (
                                <div className={mostrarLote ? 'hide' : ''}>
                                    {props.onGetFieldDecorator(`arrNumeroLote[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            value={value}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}
                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: (seriePorProducto) ? 'Series' : '',
                        dataIndex: 'detalleSeries',
                        key: 'detalleSeries',
                        width: (seriePorProducto) ? 90 : 0,
                        ellipsis: true,
                        render: (value, row) => {
                            return (
                                <div className={row.flagAplicarSerie ? '' : 'hide'}
                                    onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue)}
                                >
                                    {props.onGetFieldDecorator(`arrDetalleSeries[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrDetalleSeries[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}

                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'nombreUnidadMedida',
                        key: 'nombreUnidadMedida',
                        width: 120,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridUnidadMedida[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(

                                        row.isItemLibre ?
                                            <Select showSearch labelInValue
                                                placeholder={"Seleccione Tipo Unidad de Medida"}
                                                optionFilterProp="children"
                                                onChange={(option) => { props.onCalculateDetail(row, "arridUnidadMedida", option.key, 0, index); }}
                                            >
                                                {props.unidadesMedida.map(item => (
                                                    <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                ))}
                                            </Select> :
                                            conversionMedida && row.itemConversion.length > 0 && PRECIO_VENTA == props.onGetFieldValue('idTipoPrecio') ?
                                                <Select showSearch labelInValue
                                                    placeholder={"Seleccione Tipo Unidad de Medida"}
                                                    optionFilterProp="children"
                                                    onChange={(option) => { props.handleSelectConversion(row, option.key, index, row.identifier); }}
                                                    disabled={row.idTipoProducto == 2 ? true : false}
                                                >
                                                    {row.itemConversion.map(item => (
                                                        <Option key={item.idUnidadMedida} value={item.idUnidadMedida}>{item.unidadMedida}</Option>
                                                    ))}
                                                </Select>
                                                : <span> {value} </span>
                                        // <span>{value}</span>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Tipo IGV',
                        dataIndex: 'idImpuesto',
                        key: 'idImpuesto',
                        width: 220,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridImpuesto[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(

                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo IGV"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onCalculateDetail(row, "arridImpuesto", option.key, 0, index); }}
                                        >
                                            {props.tipoAfectacion.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    /*   {
                        title: 'Afecto IGV',
                        dataIndex: 'flagAfecto',
                        key: 'flagAfecto',
                        align: 'center',
                        width: 62,
                        render: (value, row, index) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrFlagAfecto[${row.identifier}]`, {
                                        valuePropName: 'checked',
                                        initialValue: value
                                    })(
                                        (props.onGetFieldValue("flagImpuesto") ?
                                            <Checkbox
                                                disabled={true}
                                                onChange={(e) => props.onCalculateDetail(row, "arrFlagAfecto", e.target.checked, 0, index)}>
                                            </Checkbox>
                                            :
                                            <Checkbox
                                                disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`) || props.flagTributosIguales}
                                                onChange={(e) => props.onCalculateDetail(row, "arrFlagAfecto", e.target.checked, 0, index)}>
                                            </Checkbox>
                                        )
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Exonerado',
                        dataIndex: 'flagExonerado',
                        key: 'flagExonerado',
                        align: 'center',
                        width: 120,
                        render: (value, row, index) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrFlagExonerado[${row.identifier}]`, {
                                        valuePropName: 'checked',
                                        initialValue: value
                                    })(
                                        (props.onGetFieldValue("flagImpuesto") ?
                                            <Checkbox
                                                disabled={true}
                                                onChange={(e) => props.onCalculateDetail(row, "arrFlagExonerado", e.target.checked, 0, index)}>
                                            </Checkbox>
                                            :
                                            <Checkbox
                                                disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`) || props.flagTributosIguales}
                                                onChange={(e) => props.onCalculateDetail(row, "arrFlagExonerado", e.target.checked, 0, index)}>
                                            </Checkbox>
                                        )
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Gratuito',
                        dataIndex: 'flagGratuito',
                        key: 'flagGratuito',
                        align: 'center',
                        width: 70,
                        render: (value, row, index) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrFlagGratuito[${row.identifier}]`, {
                                        valuePropName: 'checked',
                                        initialValue: value
                                    })(
                                        <Checkbox
                                            disabled={props.flagTributosIguales}
                                            onChange={(e) => props.onCalculateDetail(row, "arrFlagGratuito", e.target.checked, 0, index)}>
                                        </Checkbox>
                                    )}
                                </div>
                            );
                        }
                    }, */
                    {
                        title: '',//ISC
                        dataIndex: 'flagISC',
                        key: 'flagISC',
                        align: 'center',
                        render: (value, row, index) => {
                            return (
                                <div className='hide'>
                                    {props.onGetFieldDecorator(`arrFlagISC[${row.identifier}]`, {
                                        valuePropName: 'checked',
                                        initialValue: value
                                    })(
                                        <Checkbox
                                            disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`)}
                                            onChange={(e) => props.onCalculateDetail(row, "arrFlagISC", e.target.checked, 0, index)}>
                                        </Checkbox>
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: '',//ISC
                        dataIndex: 'isc',
                        key: 'isc',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                <div className="hide">
                                    {props.onGetFieldDecorator(`arrIsc[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: (impresionVU && precioUnitarioInclIGV) ? 'Valor Unitario' : '',
                        dataIndex: 'precioUnitarioSinIGV',
                        key: 'precioUnitarioSinIGV',
                        align: 'center',
                        width: (impresionVU && precioUnitarioInclIGV) ? 90 : 0,
                        render: (value, row, index) => {
                            return (
                                <Form.Item hidden={impresionVU && precioUnitarioInclIGV ? false : true}>
                                    {props.onGetFieldDecorator(`arrValorUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(precioVenta),
                                        rules: [{
                                            required: impresionVU && precioUnitarioInclIGV ? true : false,
                                            pattern: new RegExp(precioVenta == 2 ? FORMAT_2DECIMALS : FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: row.flagAfecto ? (impresionVU && precioUnitarioInclIGV) ? true : false : false,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: ""
                                        }
                                        ]
                                    })(
                                        <Input
                                            disabled={props.precioUnitarioDisabled ? true : impresionVU && precioUnitarioInclIGV ? false : true}
                                            placeholder="V. Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => props.onCalculateDetail(row, "arrValorUnitario", e.target.value, 5, index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: (precioUnitarioInclIGV ? 'Precio Unitario' : 'Valor Unitario'),
                        dataIndex: 'precioUnitario',
                        key: 'precioUnitario',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(precioVenta),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(precioVenta == 2 ? FORMAT_2DECIMALS : FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: row.flagAfecto ? true : false,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: ""
                                        }
                                        ]
                                    })(
                                        <Input
                                            disabled={props.precioUnitarioDisabled}
                                            placeholder="P. Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPrecioUnitario", e.target.value, 5, index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Tooltip title={validarStock ? (row.stock ? `Stock Disponible: ${row.stock.toFixed(2)}` : '') : ''}>
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                            initialValue: parseFloat(value).toFixed(cantidadVenta),
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(cantidadVenta == 2 ? FORMAT_2DECIMALS : FORMAT_3DECIMALS),
                                                    message: "Formato (0.00)"
                                                },
                                                {
                                                    required: true,
                                                    pattern: new RegExp(GREATER_THAN_ZERO),
                                                    message: ""
                                                }
                                            ]
                                        })(
                                            <Input
                                                disabled={row.flagAplicarSerie ? true : false}
                                                onKeyPress={global.onKeyPressDecimals}
                                                placeholder="Cantidad"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCalculateDetail(row, "arrCantidad", e.target.value, 3, index)}
                                            />
                                        )}
                                    </Form.Item>
                                </Tooltip>
                            );
                        }
                    },
                    {
                        title: 'Total Detalle',
                        dataIndex: 'totalDetalle',
                        key: 'totalDetalle',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrTotalDetalle[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Porcentaje Descuento',
                        dataIndex: 'porcentajeDescuento',
                        key: 'porcentajeDescuento',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPorcentajeDescuento[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`)}
                                            placeholder="% Desc."
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPorcentajeDescuento", e.target.value, 2, index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Importe Descuento',
                        dataIndex: 'importeDescuento',
                        key: 'importeDescuento',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrImporteDescuento[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`)}
                                            placeholder="Imp. Desc."
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrImporteDescuento", e.target.value, 2, index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Sub Total',
                        dataIndex: 'subTotal',
                        key: 'subTotal',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrSubTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'IGV',
                        dataIndex: 'igv',
                        key: 'igv',
                        align: 'center',
                        width: 80,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrIgv[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                        fixed: 'right',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={props.totalDisabled}
                                            placeholder="Total"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrTotal", e.target.value, 2, index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                ]}
            />
        </div>
    );
}